import {Role} from '../auth/role';

export interface User extends EmailModel {
  id: string;
  email: string;
  emailVerified: boolean;
  roles: Role[];
  organizationId: string;
}

export interface UserLoyalty {
  loyaltyScore: number;
  level: LoyaltyLevel;
}

export enum LoyaltyLevel {
  DEVOTED = 'DEVOTED',
  LOYAL = 'LOYAL',
  FREQUENT = 'FREQUENT',
  CASUAL = 'CASUAL',
  STRANGER = 'STRANGER'
}

export function getLoyaltyLevel(value: number): LoyaltyLevel {
  if (value >= loyaltyLevelMinimalNumericValues[LoyaltyLevel.DEVOTED]) {
    return LoyaltyLevel.DEVOTED;
  }
  if (value >= loyaltyLevelMinimalNumericValues[LoyaltyLevel.LOYAL]) {
    return LoyaltyLevel.LOYAL;
  }
  if (value >= loyaltyLevelMinimalNumericValues[LoyaltyLevel.FREQUENT]) {
    return LoyaltyLevel.FREQUENT;
  }
  if (value >= loyaltyLevelMinimalNumericValues[LoyaltyLevel.CASUAL]) {
    return LoyaltyLevel.CASUAL;
  }

  return LoyaltyLevel.STRANGER;
}

export const loyaltyLevelMinimalNumericValues = {
  [LoyaltyLevel.STRANGER]: 0,
  [LoyaltyLevel.CASUAL]: 1,
  [LoyaltyLevel.FREQUENT]: 2,
  [LoyaltyLevel.LOYAL]: 5,
  [LoyaltyLevel.DEVOTED]: 8,
}

export interface UserVerificationCodeModel {
  code: string;
}

export interface LoginModel extends PasswordModel {
  username: string;
}

export interface EmailModel {
  email: string;
}

export interface PasswordModel {
  password: string;
}

export interface ResetPasswordModel extends UserVerificationCodeModel, PasswordModel {
}
